import * as React from "react";
const SvgFiRrMap = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-map_svg__a)">
      <path
        fill="#062147"
        d="m20.68 1.167-.021-.007-2.715-.9a5 5 0 0 0-2.9-.079l-5.576 1.62a3.03 3.03 0 0 1-2.048-.18l-.5-.233A5 5 0 0 0 0 6v12.075a5.01 5.01 0 0 0 3.6 4.8l2.869.9c.484.15.988.227 1.495.225.452.006.902-.055 1.336-.18l5.8-1.6c.53-.144 1.09-.14 1.617.012l2.343.676A4 4 0 0 0 24 19.021V5.876a5.01 5.01 0 0 0-3.32-4.709M4.176 20.96A3.01 3.01 0 0 1 2 18.075V6a2.95 2.95 0 0 1 1.336-2.5A3 3 0 0 1 5 3a2.9 2.9 0 0 1 1.112.222s.745.32.887.37v18.25zM9 21.827V3.88q.511-.027 1.006-.155L15 2.274V20.2zm13-2.806a2 2 0 0 1-2.433 1.954L17 20.252V2.075l3.018.98A3.01 3.01 0 0 1 22 5.875z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-map_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMap;
